import React, { useContext } from 'react';
import { DisclosureItemContext } from './disclosureItem.context';
export const DisclosureClose = ({ children, }) => {
    const { toggleOpen } = useContext(DisclosureItemContext);
    const keyDown = (event) => {
        if (event.key && (event.key == 'Enter' || event.key == ' ')) {
            toggleOpen();
        }
    };
    return React.cloneElement(children, {
        onClick: toggleOpen,
        onKeyDown: (e) => keyDown(e),
    });
};
//# sourceMappingURL=disclosureClose.js.map